// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { InvoiceHeader } from './invoice-header';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class InvoiceStatus extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** String(10) key */
  id!: string;
  /** String(50) */
  name!: string;
  /** Inv FK invoiceStatusId */
  invoiceHeaders!: InvoiceHeader[];
}

